import React from "react";
import styled, { keyframes } from "styled-components";

const MessageLoadingThink = () => {
    return (
        <MessageContainer>
            <MessageBox>
                <GradientText>더 좋은 응답을 위해 더 오래 생각하는 중...</GradientText>
            </MessageBox>
        </MessageContainer>
    );
};

const shineAnimation = keyframes`
  from {
    background-position: 100% 50%;
  }
  to {
    background-position: 0% 50%;
  }
`;

const GradientText = styled.span`
    background: linear-gradient(90deg, #000 30%, white 50%, #000 70%);
    background-size: 200% auto;

    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;

    animation: ${shineAnimation} 1.2s linear infinite;
`;

const MessageContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-bottom: 12px;
`;

const MessageBox = styled.div`
    max-width: 90%;
    padding: 10px 14px;
    border-radius: 20px;
    white-space: pre-wrap;
    line-height: 1.5;
    font-size: 15px;
    word-break: break-word;

    background-color: #f1f1f1;
    color: #000000;
    border-bottom-left-radius: 4px;
`;

export default MessageLoadingThink;
